import React from 'react'
import { TourStop } from 'Components/tourStop'
import { MainMedia as Media } from 'Components/tourStop'
import { useSelector } from 'react-redux'
import { useGetAiSearchQuery } from 'Services/ai'
import { Accordion, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { AccordionHeading } from 'Components/accordionHeading'

export const AiSearchResults = () => {
  const { search } = useSelector((state: any) => state.ai)
  const { locId, tourId, stops, labels } = useSelector((state: any) => state.location)

  const {
    data: searchData,
    isSuccess,
    isFetching,
  } = useGetAiSearchQuery(
    {
      tourId: tourId,
      locId: locId,
      search: search,
    },
    { skip: !search }
  )

  const sortedData = searchData?.resources?.data?.reduce(
    (acc, item) => {
      if (item.media_type === 'stop_description') {
        acc.stops.push(item)
      } else {
        acc.media.push(item)
      }
      return acc
    },
    { stops: [], media: [] }
  )

  const renderSearchItem = (searchItem: any) => {
    switch (searchItem.media_type) {
      case 'stop_description':
        if (stops?.length > 0) {
          const stop = stops.find((stop) => stop.stopid === searchItem.stop_id)
          return (
            <TourStop
              personalized={false}
              key={searchItem.stop_id}
              stopData={stop}
              labels={labels}
            />
          )
        }
      default:
        return (
          <Media
            info={true}
            key={searchItem.id}
            id={searchItem.media_id}
            type={
              searchItem.media_type === 'pano'
                ? 'panorama'
                : searchItem.media_type
            }
          />
        )
    }
  }

  if (search && isSuccess && !isFetching && searchData?.resources?.data) {
    return (
      <Accordion
        sx={{ mt: 2 }}
        defaultExpanded={true}
        slotProps={{ transition: { unmountOnExit: true } }}
      >
        <AccordionHeading
          level={2}
          expandIcon={<ExpandMoreIcon />}
          aria-controls='ai-search-results-content'
          id='ai-search-results-header'
        >
          Search Results for {search}
        </AccordionHeading>
        <AccordionDetails id='ai-search-results-content'>
          {sortedData.stops.map((searchItem) => renderSearchItem(searchItem))}
            <Accordion
            sx={{ mt: 0 }}
            defaultExpanded={true}
            slotProps={{ transition: { unmountOnExit: true } }}
          >
            <AccordionHeading
              level={3}
              expandIcon={<ExpandMoreIcon />}
              aria-controls='ai-search-media-gallery-content'
              id='ai-search-media-gallery-header'
            >
              Media Gallery
            </AccordionHeading>
            <AccordionDetails id='ai-search-media-gallery-content'>

            {sortedData.media.length > 0 ? (
              sortedData.media.map((searchItem) =>
                renderSearchItem(searchItem)
              )
            ) : (
              <span>No media results</span>
            )}
            </AccordionDetails>

            
          </Accordion>
          
          
        </AccordionDetails>
      </Accordion>
    )
  }
  return null
}
